var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"main",attrs:{"id":"main"}},[_c('keep-alive',[_c('header',{staticClass:"header"},[_c('TopMenu')],1)]),_c('div',{style:(_vm.stylee)},[_c('keep-alive',[_c('aside',{staticClass:"aside",staticStyle:{"position":"absolute"}},[_c('aside-menu')],1)]),_c('div',{staticClass:"main"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }